module.exports = __webpack_public_path__ + "img/Group 34085@2x.dfc1b1d9.png";